import {
	all,
	Div,
	not,
	reactive,
} from 'alkali'
import { default as app, userSettings } from 'app/app'
import Icon from 'components/Icon'
import * as DALogo from 'images/Updated-Logo.svg'
import { StudyList } from 'components/studies/StudyList'
import { ResultsGrid } from 'components/analysis/ResultsGrid'
import { Entry } from 'pages/Entry'
import FilterPane from 'components/filter/FilterPane'
import { ReturnPane } from 'components/faq/ReturnPane'
import { AnalysisSelectionHeader } from 'components/analysis/AnalysisSelectionHeader'
import CustomResults from 'components/analysis/CustomResults'
import MetaAnalysisReport from 'components/analysis/MetaAnalysisReport'
import {
	studiesSearch,
} from 'model/EvidenceSearch'
import { analysisResults, view as analysisView } from 'model/Analysis'
import { studyCollection, activeTab, tabFilter } from 'model/StudyCollection'
import { screening } from 'model/Screening'
import { analysisType, whenInitialSearch, isEntryPage, readonlyMode } from 'model/SearchQuery'
import { groupConnectivity } from 'model/GroupConnectivity'
import { bindToHashParameter } from '../app/navigation'
import { expandedConditions, expandedInterventions } from 'components/studies/StudyHeader'
import { detailsExpanded, studyDetailsPane } from 'components/studies/StudyDetailsPane'
import { openFilterPane } from 'components/navbar/FilterButton'
import { StudiesTabs } from 'components/studies/StudiesTabs'
import {removeContents } from 'components/entry/Explanation'

window.analysisType = analysisType

export let evidenceInstance
// Complete list of all attributes in the study set
export default class EvidenceResults extends Div('.evidently-results', {
	classes: {
		'readonly-mode': readonlyMode,
		'faq-mode': isFAQDashboard,
		'show-term-highlights': userSettings.to(settings => !settings?.HideHighlights),
	},
}) {
	created(properties) {
		this.activeTab = activeTab
		properties.classes.screening = activeTab.to((tab) => tab == 'screening')
		properties.classes['screening-started'] = screening.to(Boolean)
		properties.classes.extract = activeTab.to((tab) => tab == 'extract')
		properties.classes['analysis-view'] = activeTab.to((tab) => tab == 'report')
		properties.classes['analyzable-view'] = activeTab.to((tab) => tab == 'analyzable')

		// Tab filtering classes
		properties.classes['filter-applied'] = tabFilter.to((filter) => filter.valueOf().length > 0)
		properties.classes['include-view'] = tabFilter.to((filter) => filter.includes('Included'))
		properties.classes['uncertain-view'] = tabFilter.to((filter) => filter.includes('Uncertain'))
		properties.classes['rejected-view-design'] = tabFilter.to((filter) => filter.includes('Wrong study design'))
		properties.classes['rejected-view-population'] = tabFilter.to((filter) => filter.includes('Wrong population'))
		properties.classes['rejected-view-intervention'] = tabFilter.to((filter) => filter.includes('Wrong intervention'))
		properties.classes['rejected-view-outcome'] = tabFilter.to((filter) => filter.includes('Wrong outcome'))
		properties.classes['rejected-view-any'] = tabFilter.to((filter) => filter.includes('Any reason'))
		properties.classes['selected-view'] = tabFilter.to((filter) => filter == 'Selected')
	}
	ready(opts) {
		let searchWidget, studiesWidget, treatmentsWidget, charWidget, outcomesWidget
		evidenceInstance = this

		let isLoaded = reactive(false)
		studiesSearch.subscribe(() => {
			if (isLoaded.valueOf() && activeTab.valueOf() != 'extract') {
				activeTab.put('sources')
			}
		})
		setTimeout(
			() =>
				Promise.resolve(whenInitialSearch).then(() => setTimeout(() => (isLoaded.put(true)), 150)),
			100
		)

		let debugMode = reactive(false)
		bindToHashParameter({
			variable: debugMode,
			parameter: 'debug',
		})
		if (analysisType == 'ai') analysisType.put('auto')
		if (analysisType == 'network') analysisType.put('bayesian')
		this.append(
			AnalysisSelectionHeader.with({ activeTab, evidenceResults: this }),
			Div(isFAQDashboard ? '.faq-columns.evidence-columns' : '.evidence-columns', [
				Div('.tabs-container', {display: isLoaded, content: [StudiesTabs.with({ evidenceResults: this })] }),
				isFAQDashboard ?
					ReturnPane.with({ evidenceResults: this }) :
					isEntryPage ? null : FilterPane.with({activeTab}),
				Div('.studies-pane', [
					Div('.custom-report'),
					(this.resultsGrid = new ResultsGrid({
						collection: analysisResults,
						activeTab,
					})),
					(studiesWidget = new Div('.studies-container', {
						classes: {
							'experimental-conditions': Boolean(
								localStorage.getItem('experimental-conditions')
							),
							'expanded-interventions': expandedInterventions,
							'expanded-conditions': expandedConditions,
						},
					})),
					studyDetailsPane,
				],
				{
					classes: {
						'direct-meta': all(
							[activeTab, analysisType],
							(activeTab, analysisType) => activeTab == 'report' && analysisType === 'direct'
						),
						'network-analysis': analysisType.to(
							(analysisType) =>
								analysisType == 'bayesian' ||
								analysisType == 'frequentist' ||
								(analysisType == 'auto' &&
									groupConnectivity.to(({ complete }) => complete > 2).whileResolving(true, true))
						),
						'cohort-analysis': analysisType.to(
							(analysisType) =>
								analysisType == 'cohort' ||
								(analysisType == 'auto' &&
									groupConnectivity.to(({ complete }) => complete == 1).whileResolving(false))
						),
						'evidence-table': analysisType.to(analysisType => analysisType == 'evidence-table'),
						'forest-plot': activeTab.to((activeTab) => activeTab == 'report'),
						'bar-chart': activeTab.to((activeTab) => activeTab == 'sources'),
						'medium-open-articles': openFilterPane,
						'medium-hide-articles': not(openFilterPane),
						'details-expanded': detailsExpanded,
					},
				}),
				window.isCovid ? document.getElementById('covid-questions-list') : null,
				isEntryPage ? Entry : null,
			]),
			)
			
			
			let topSuggestionUris
			let topSuggestionTerm
			analysisType.subscribe(() => {
				if (analysisType.valueOf() && analysisType != 'auto' && !app.user) {
					alert('Must sign up or login to use analysis')
					return app.authentication.showLogin()
				}
			})

		studiesWidget.append(
			(this.studyList = new StudyList({
				studyDetailsPane,
			}))
		)

		studyDetailsPane.studyList = this.studyList
		activeTab.subscribe(() => {
			if (/*analysisType == 'direct' && */ activeTab != 'report') {
				this.showSources()
			}
		})
		if (activeTab == 'report') studyCollection.then(() => this.showAnalysis(true))
		return
	}

	lastAnalysisResult: HTMLElement
	activeTab: VString
	showSources() {
		let customReport = this.querySelector('.loader')
		if (customReport != null) {
			customReport.remove()
		}
		let loader = this.querySelector('.loader')
		if (loader != null) {
			loader.remove()
		}
		analysisView.put('bar-chart')
		this.classList.remove('showing-custom-report')
		this.studyList.switchToSources()
		this.resultsGrid.switchToSources()
		this.querySelector('.custom-report')?.firstChild?.innerHTML = ''
		setTimeout(() =>
			window.dispatchEvent(new Event('resize')), 1000) // delay one second, because scroll position may be dependent on post-animation positioning
	}
	hasRunAnalysis: boolean
	showAnalysis(immediate) {
		app.user?.Settings?.Tour?.MetaReport
			? removeContents()
			: null // startExplanations(6, true, false, null) TODO: Update tour navigation
		this.hasRunAnalysis = true
		this.activeTab.put('report')
		this.runAnalysis(immediate)
	}
	runAnalysis(immediate) {
		if (analysisType == 'custom') {
			return this.runRCustomReport()
		}
		analysisView.put('forest-plot')
		this.studyList.switchToForestPlot(immediate)
		this.resultsGrid.switchToForestPlot()
	}
	metaAnalysisReport(options) {
		this.createLoader()
		document.querySelector('.meta-analysis').classList.add('disabled-link')
		this.className += ' showing-custom-report'
		let customReport = this.querySelector('.custom-report')
		if (this.lastAnalysisResult) customReport.removeChild(this.lastAnalysisResult)
		customReport.append(
			(this.lastAnalysisResult = new MetaAnalysisReport({
				config: Object.assign(
					{
						isUserTemplate: false,
						tab: false,
					},
					options
				),
			}))
		)
	}
	runRCustomReport() {
		this.className += ' showing-custom-report'
		let customReport = this.querySelector('.custom-report')
		if (this.lastAnalysisResult) customReport.removeChild(this.lastAnalysisResult)
		customReport.append(
			(this.lastAnalysisResult = new CustomResults({
				config: {
					isUserTemplate: true,
					workflows: [],
				},
				template: reactive({
					sections: [],
					headerR: '',
				}),
				workflow: reactive({
					deferChildrenRendering: false,
				}),
			}))
		)
	}
	always() {
		app.main.sidebar.hide()
		app.main.sidebar.setControls(null)
	}

	destroy() {
		super.destroy()
	}
	createLoader() {
		let customReport = this.querySelector('.custom-report')
		customReport.appendChild(new Div('.loader', [Div, Div, Div]))
	}
}
